import { Briefcase, Building2, Store, Play } from "lucide-react";
import { Section } from "./ui";
import { DemoPlayer } from "./DemoPlayer";

const CASES = [
  { icon: Briefcase, who: "Prestataire informatique · plusieurs dizaines de clients", text: "Un client appelle : son poste apparaît en ligne, le technicien prend la main en un clic et règle le problème pendant l'appel. Le 1er du mois, chaque client reçoit son rapport PDF sans que personne n'y touche." },
  { icon: Building2, who: "Service informatique interne · siège et télétravail", text: "Les mises à jour Windows sont validées le lundi et installées le mardi soir. Les collègues choisissent quand redémarrer, et un disque presque plein est signalé dans le résumé du matin avant de bloquer quelqu'un." },
  { icon: Store, who: "Commerce avec caisse et poste de gestion", text: "Le logiciel de caisse plante un samedi : le technicien se connecte à distance, voit la demande d'autorisation Windows, installe la correction et la boutique reprend sans déplacement." },
];

export const Demo = () => (
  <Section id="demo" over="DÉMO" title="ScreenView en 30 secondes" lead="Un dépannage et une installation à distance, tels que le technicien les vit dans ScreenView.">
    <DemoPlayer />
    <p className="flex flex-wrap items-center gap-1.5 text-xs text-slate-500 mt-3"><Play className="h-3.5 w-3.5" />Animation réalisée à partir des vrais écrans de ScreenView, avec des données de démonstration.
      <a href="/landing/screenview-demo.mp4" download className="ml-2 text-sky-400 hover:text-sky-300 font-semibold" data-testid="demo-video-download">Télécharger la vidéo (MP4, 42 s)</a>
    </p>
  </Section>
);

export const UseCases = () => (
  <Section id="cas-usage" className="bg-[#0B1120]" over="CAS D'USAGE" title="ScreenView au quotidien, en trois situations">
    <div className="grid md:grid-cols-3 gap-5">
      {CASES.map((c) => (
        <div key={c.who} className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6" data-testid="use-case-card">
          <c.icon className="h-6 w-6 text-sky-400 mb-4" />
          <p className="text-sm font-semibold text-slate-200 mb-3">{c.who}</p>
          <p className="text-sm text-slate-400 leading-relaxed">{c.text}</p>
        </div>
      ))}
    </div>
    <p className="text-xs text-slate-500 mt-4">Scénarios types, présentés à titre d'illustration. Les témoignages de nos clients arrivent bientôt.</p>
  </Section>
);
